import { FC, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@mui/material';

const StyledBox = styled(Box)`
  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
`;

interface Props extends PropsWithChildren {
  icon: ReactNode;
  title: string;
}

const InsightsBox: FC<Props> = ({ icon, title, children }) => (
  <StyledBox>
    {icon}
    <Typography fontWeight="bold">{children}</Typography>
    <Typography color="text.secondary" fontSize="caption">
      {title}
    </Typography>
  </StyledBox>
);

export default InsightsBox;
